// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath } from '@tcp/core/src/utils/utils';
import Address from '@tcp/core/src/components/common/molecules/Address';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles from '../styles/OrderBillingDetails.style';
import cardIconMapping from '../OrderBillingDetails.constants';
import {
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  ACCOUNT_ORDERS_LABEL,
  OrderDetailLabels,
  lblOrderDetailsBilling,
  lblOrdersEnding,
} from '../../../container/OrderDetails.labels';
import { parseBoolean } from '../../../../../../../utils';

const isAfterPayPayment = (card) => parseBoolean(card && card.afterpay);

const getCardType = (card, isCashAppAfterpayLogoEnabled) => {
  const { cardType = '' } = card || {};
  if (isAfterPayPayment(card)) {
    return isCashAppAfterpayLogoEnabled ? 'CASHAPP-AFTERPAY' : 'AFTERPAY';
  }
  return cardType.toUpperCase();
};

const billingIcon = (card, orderLabels) => {
  return card.cardType.toUpperCase() !== 'APPLEPAY' && !isAfterPayPayment(card)
    ? `${getLabelWithDefaultValue(orderLabels, lblOrdersEnding)} ${card.endingNumbers.slice(-4)}`
    : '';
};

/**
 * This function component use for return the OrderBillingDetails
 * can be passed in the component.
 * @param ordersLabels - ordersLabels object used for showing Orders Labels
 */

const OrderBillingDetails = ({ className, orderDetailsData, isCashAppAfterpayLogoEnabled }) => {
  /**
   * @function return  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */

  const { checkout, appliedGiftCards } = orderDetailsData;
  const { billing } = checkout;
  const { card } = billing;
  const isApplePayment = card && card.cardType && card.cardType.toUpperCase() === 'APPLEPAY';
  const orderLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_ORDERS_LABEL, OrderDetailLabels);
  const isAfterpay = isAfterPayPayment(card);
  const ccType = getCardType(card || {}, isCashAppAfterpayLogoEnabled);
  const cardType = ccType?.toLowerCase().includes('place') ? `${ccType}_PJP` : ccType;

  const paymentMethodGiftCardOnly = () => {
    return !!(appliedGiftCards?.length > 0 && !card?.cardType?.length);
  };

  return (
    <BodyCopy component="div" className={className}>
      <BodyCopy fontSize="fs14" fontWeight="extrabold" fontFamily="secondary">
        {getLabelWithDefaultValue(orderLabels, lblOrderDetailsBilling)}
      </BodyCopy>
      <BodyCopy component="div">
        <Row fullBleed className="elem-mb-XS">
          {card && (
            <Col className="card-details" colSize={{ large: 12, medium: 4, small: 3 }}>
              {isAfterpay && isCashAppAfterpayLogoEnabled ? (
                <div className="elem-mr-XS cashapp-afterpay-wrapper">
                  <Image
                    src={getIconPath(cardIconMapping[cardType])}
                    alt={card.cardType}
                    className="cashapp-afterpay-button"
                  />
                </div>
              ) : (
                <>
                  <Image
                    src={getIconPath(cardIconMapping[cardType])}
                    alt={card.cardType}
                    className="elem-mr-XS card-border"
                  />
                  <BodyCopy fontSize="fs12" fontFamily="secondary" fontWeight="extrabold">
                    {card.cardType.toUpperCase() !== 'VENMO'
                      ? billingIcon(card, orderLabels)
                      : card.endingNumbers}
                  </BodyCopy>
                </>
              )}
            </Col>
          )}
          {appliedGiftCards &&
            appliedGiftCards.length > 0 &&
            appliedGiftCards.map((giftCard) => {
              return (
                <Col className="card-details" colSize={{ large: 12, medium: 4, small: 3 }}>
                  <Image
                    src={getIconPath(
                      cardIconMapping[giftCard.cardType.toUpperCase().replace(' ', '')]
                    )}
                    alt={giftCard.cardType}
                    className="elem-mr-XS card-border"
                  />
                  <BodyCopy fontSize="fs12" fontFamily="secondary" fontWeight="extrabold">
                    {giftCard.endingNumbers
                      ? `${getLabelWithDefaultValue(
                          orderLabels,
                          lblOrdersEnding
                        )} ${giftCard.endingNumbers.slice(-4)}`
                      : ''}
                  </BodyCopy>
                </Col>
              );
            })}
        </Row>
      </BodyCopy>

      {!isApplePayment && !isAfterPayPayment(card) && !paymentMethodGiftCardOnly() && (
        <BodyCopy component="div" fontSize="fs14" fontFamily="secondary">
          <Address address={billing.billingAddress} showCountry={false} showPhone={false} />
        </BodyCopy>
      )}
    </BodyCopy>
  );
};
OrderBillingDetails.propTypes = {
  className: PropTypes.string,
  orderDetailsData: PropTypes.shape({}),
  isCashAppAfterpayLogoEnabled: PropTypes.bool,
};

OrderBillingDetails.defaultProps = {
  className: '',
  orderDetailsData: {},
  isCashAppAfterpayLogoEnabled: false,
};

export default withStyles(OrderBillingDetails, styles);
export { OrderBillingDetails as OrderBillingDetailsVanilla };
